var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "grid grid-cols-1 gap-3 m-auto p-3 bg-white border-l border-r border-b pt-5 pb-8 px-6 rounded-b-lg shadow-xl",
    staticStyle: {
      "max-width": "24rem"
    }
  }, [_c('h4', {
    staticClass: "font-bold text-base uppercase text-inverse-800"
  }, [_vm._v(" Reset Password ")]), _c('p', {
    staticClass: "text-gray-700"
  }, [_vm._v(" Enter the email address associated with your account to reset your password. ")]), _c('YInput', {
    attrs: {
      "label": "Email"
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  }), _c('YButton', {
    staticClass: "w-full",
    attrs: {
      "color": "pink",
      "is-loading": _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")]), _vm.successMessage ? _c('YAlert', {
    staticClass: "mt-2",
    attrs: {
      "color": "green",
      "allow-close": false
    }
  }, [_vm._v(" " + _vm._s(_vm.successMessage) + " ")]) : _vm._e(), _c('portal-target', {
    attrs: {
      "name": "errors"
    }
  }), _c('div', {
    staticClass: "flex justify-between border-t border-gray-500 pt-4 mt-3"
  }, [_c('p', {
    staticClass: "text-gray-700"
  }, [_vm._v("Don't have an account?")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'Register'
      }
    }
  }, [_c('p', {
    staticClass: "link"
  }, [_vm._v("Sign Up")])])], 1), _vm.validationErrors ? _c('ValidationErrors', {
    attrs: {
      "errors": _vm.validationErrors,
      "portal-to": "errors",
      "alert-class": "text-xs",
      "icon-size": 12,
      "icon": null,
      "color": "yellow"
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }